import { useState, useEffect } from "react";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Container from "./components/Container";
import ReviewCard from "./components/ReviewCard";
import EmptyState from "./components/EmptyState";
import { getComments } from "./api";
import styles from "./pages/Results.module.css";

const normalize = (row) => ({
  text: row.description ?? row.review ?? "",
  when: row.when ?? "",
});

const isEmpty = (rows) =>
  !Array.isArray(rows) || rows.length === 0 || rows[0].table === "Comments are Empty";

export default function Comments() {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await getComments(localStorage.getItem("user_id"));
        setRows(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.log(error);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  const shown = isEmpty(rows) ? [] : rows.map(normalize);

  return (
    <div>
      <Nav />
      <main className={styles.page}>
        <Container>
          <div className={styles.head}>
            <h1 className={styles.title}>Comments about you</h1>
            <p className={styles.muted}>Feedback left by the admin team.</p>
          </div>
          {shown.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "var(--s3)", maxWidth: 640 }}>
              {shown.map((c, i) => (
                <ReviewCard key={i} when={c.when} text={c.text} />
              ))}
            </div>
          ) : (
            loaded && (
              <EmptyState title="No comments yet" message="You have no comments from the team yet." />
            )
          )}
        </Container>
      </main>
      <Footer />
    </div>
  );
}
